export default function getStockStatusColor(status) {
    switch (status) {
        case 0: //draft
            return "blue";
        case 1: //active
            return "green";
        case 2: //closed
            return "indigo";
        case 3: //error
            return "red";
        default: //withoutClientInvoice
            return "orange";
    }
}